import { Component, OnDestroy } from '@angular/core';
import { FooterComponent } from '../../../../landing-page-v2/components/footer/footer.component';
import { HeaderComponent } from '../../../../landing-page-v2/components/header/header.component';
import { FixedCallComponent } from '../../fixed-call/fixed-call.component';

@Component({
  selector: 'app-healthcare-industry',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, FixedCallComponent],
  templateUrl: './healthcare-industry.component.html',
  styleUrl: './healthcare-industry.component.scss',
})
export class HealthcareIndustryComponent implements OnDestroy {
  constructor() {}

  ngOnDestroy(): void {}
}
